import Badge from "@mui/material/Badge";
import { useColorScheme } from "@mui/material/styles";
import { MouseEvent } from "react";
import { IoNotifications } from "react-icons/io5";

import HeaderIconButton, { headerBadgeSx } from "@/components/Core/HeaderIconButton";
import { useTranslate } from "@/hooks";
import { colors } from "@/theme";

interface NotificationBellProps {
  unreadCount: number;
  open: boolean;
  mode: ReturnType<typeof useColorScheme>["mode"];
  onClick: (event: MouseEvent<HTMLElement>) => void;
}

export const NotificationBell = ({ unreadCount, open, onClick }: NotificationBellProps) => {
  const t = useTranslate();

  return (
    <Badge badgeContent={unreadCount} overlap="circular" max={99} sx={headerBadgeSx(colors.red)}>
      <HeaderIconButton
        label={t("header.notifications")}
        active={open}
        onClick={onClick}
        aria-controls={open ? "notification-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        <IoNotifications aria-hidden />
      </HeaderIconButton>
    </Badge>
  );
};
